<template>
  <div class="content">
    <div class="bodycontent">
      <el-form :model="form" ref="formData" label-width="180px">
        <el-form-item label="活动名称">
          <el-input
            v-model="form.task_name"
            class="input_box"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-date-picker
            size="small"
            v-model="form.start_time"
            type="datetime"
            placeholder="选择开始日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          至
          <el-date-picker
            size="small"
            v-model="form.end_time"
            type="datetime"
            placeholder="选择结束日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="参与门店" prop="type_id">
          <!--          <el-radio-group v-model="isroom" @change="room_seclect">-->
          <!--            <el-radio label="0">全部门店</el-radio>-->
          <!--            <el-radio label="1">部分门店</el-radio>-->
          <!--          </el-radio-group>-->
          <el-select
            size="small"
            v-model="room_ids"
            multiple
            collapse-tags
            style="margin-left: 20px;"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in room_options"
              :key="i"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="油品选择" prop="goods_id">
          <el-radio-group v-model="form.goods_id">
            <el-radio v-for="(ite, i) in goodsarrs" :key="i" :label="ite.id">{{
              ite.name
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员等级选择" prop="goods_id">
          <el-checkbox-group v-model="population_level_ids">
            <el-checkbox
              v-for="(ite, i) in level_Group_Select"
              :label="ite.id"
              :key="i"
              >{{ ite.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适用人群" prop="type_id">
          <el-radio-group v-model="tags">
            <el-radio label="0">所有人群</el-radio>
            <el-radio label="1">指定标签</el-radio>
          </el-radio-group>
          <el-select
            size="small"
            :disabled="tags == 0"
            v-model="population_tag_ids"
            multiple
            collapse-tags
            style="margin-left: 20px;"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in vip_options"
              :key="i"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消费金额是否可重复累计">
          <el-radio-group v-model="form.is_money_repeat">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div style="width:600px;display: flex;margin-left: 110px">
        <div>
          消费满
          <el-input
            v-model="form.money"
            size="small"
            style="width: 100px"
          ></el-input>
          元
        </div>
        <div style="margin-left: 30px">
          <div style="margin-top: 6px;font-weight: bold">赠送内容</div>
          <div style="margin-top: 6px;">
            <el-checkbox v-model="is_gift_balance">
              送
              <el-input
                v-model="form.gift_balance"
                size="small"
                style="width: 100px"
                @focus="is_gift_balance = true"
              ></el-input>
              元余额
            </el-checkbox>
          </div>
          <div style="margin-top: 6px">
            <el-checkbox v-model="is_gift_integral">
              送
              <el-input
                v-model="form.gift_integral"
                size="small"
                style="width: 100px"
                @focus="is_gift_integral = true"
              ></el-input>
              积分
            </el-checkbox>
          </div>
          <div style="margin-top: 6px">
            <el-checkbox v-model="is_gift_coupon">
              <div style="display: flex; flex-wrap: wrap;align-items: center">
                <div style="margin-right: 5px">送券</div>
                <el-tag
                  style="margin-bottom: 5px; margin-right: 5px"
                  v-for="(item, i) in couponLists"
                  :key="i"
                  closable
                  @close="handleClose(item, i)"
                >
                  {{ item.name }} 【{{ item.choseNum }}】
                </el-tag>
                <el-button
                  size="small"
                  @click="(show_coupon = true), (is_gift_coupon = true)"
                  >选择券</el-button
                >
              </div>
            </el-checkbox>
          </div>
        </div>
      </div>

      <div class="bottom_btn">
        <el-button type="primary" @click="sub">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="show_coupon"
      @close="show_coupon = false"
      width="800px"
    >
      <selectCommodity
        @close="show_coupon = false"
        @getCommod="getCommod"
        :sList="couponLists"
        :jude="2"
      ></selectCommodity>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import selectCommodity from "@/components/commodity/newSelectCommodityNum.vue";
import { goodsOptions, vipList } from "@/api/vip";
import { selectStoreList } from "@/api/storeManage";
import { allTag, manage_add } from "@/api/market";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    selectCommodity
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      isroom: "",
      tags: "",
      couponLists: [],
      show_coupon: false,
      is_gift_coupon: false,
      is_gift_integral: false,
      is_gift_balance: false,
      form: {
        task_name: "",
        start_time: "",
        end_time: "",
        room_ids: "",
        goods_id: "",
        is_money_repeat: "",
        money: "",
        is_gift_balance: "",
        gift_balance: "",
        is_gift_integral: "",
        gift_integral: "",
        is_gift_coupon: "",
        gift_coupon_info: "",
        population_level_ids: "",
        population_tag_ids: ""
      },
      room_ids: [],
      room_options: [],
      level_Group_Select: [],
      vip_options: [],
      goodsarrs: [],
      population_level_ids: [],
      population_tag_ids: []
    };
  },
  methods: {
    //提交
    async sub() {
      console.log(
        this.population_level_ids,
        this.population_tag_ids,
        this.room_ids
      );
      if (
        new Date(this.form.start_time).getTime() >
        new Date(this.form.end_time).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return false;
      }
      if (this.couponLists.length > 0) {
        let arr = [];
        this.couponLists.forEach(item => {
          arr.push({
            coupon_id: item.id,
            num: item.choseNum
          });
        });
        this.form.gift_coupon_info = JSON.stringify(arr);
      }

      if (this.population_level_ids.length > 0) {
        this.form.population_level_ids = this.population_level_ids.join(",");
      }
      if (this.tags == "1") {
        if (this.population_tag_ids.length > 0) {
          this.form.population_tag_ids = this.population_tag_ids.join(",");
        }
      } else {
        this.form.population_tag_ids = "";
      }
      this.form.room_ids = this.room_ids.join(",");
      this.form.is_gift_balance = this.is_gift_balance ? "1" : "0";
      this.form.is_gift_coupon = this.is_gift_coupon ? "1" : "0";
      this.form.is_gift_integral = this.is_gift_integral ? "1" : "0";
      console.log(this.form);
      let data = {
        app_id: this.app_id,
        ...this.form
      };
      const res = await manage_add(data);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.$router.back(-1);
      } else {
        this.$message.error(res.msg);
      }
    },
    //初始化
    init() {
      this.get_levelGroupSelect();
      this.get_goodsList();
      this.get_roomList();
      this.get_allTag();
    },
    //会员等级
    async get_levelGroupSelect() {
      const res = await vipList({
        app_id: this.app_id
      });
      if (res.code == 200) {
        this.level_Group_Select = res.data;
      }
    },
    //油品
    async get_goodsList() {
      const res = await goodsOptions({
        app_id: this.app_id
      });
      if (res.code == 200) {
        this.goodsarrs = res.data;
      }
    },
    //门店
    async get_roomList() {
      const res = await selectStoreList({
        app_id: this.app_id
      });
      if (res.code == 200) {
        this.room_options = res.data;
      }
    },
    //用户标签
    async get_allTag() {
      const res = await allTag({
        app_id: this.app_id
      });
      if (res.code == 200) {
        this.vip_options = res.data;
      }
    },
    room_seclect(val) {
      if (val == "0") {
        let arr = [];
        this.room_options.forEach((ite, i) => {
          arr.push(ite.id);
        });
        this.room_ids = arr;
      }
    },
    goback() {
      this.$router.back(-1);
    },
    //选择优惠券
    getCommod(data) {
      try {
        console.log("子组件传递数据", data);
        this.couponLists = data;
        // console.log("arrrr", this.form.gift_coupon_info);
        this.show_coupon = false;
      } catch (e) {
        console.log(e);
      }
    },
    //删除优惠券
    handleClose(tag, i) {
      this.couponLists.splice(i, 1);

      console.log(this.couponLists);
    }
  }
};
</script>

<style lang="scss" scoped>
.color {
  color: #ccc;
}
.minWidth {
  min-width: 80px;
}
.buttonInput {
  width: 100px;
  padding: 0 10px;
  color: #409eff;
  height: 28px;
  line-height: 28px;
  border: 1px solid #409eff;
  border-radius: 5px;
  text-align: center;
}
.padding10 {
  padding: 0 10px;
  display: flex;
}
.margin10 {
  margin: 10px 0;
  display: flex;
}
.smallinput {
  width: 100px;
  padding: 0 10px;
}
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: #fff;
    .input_box {
      width: 400px;
    }
    .input_box_small {
      width: 120px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
}
</style>
